import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "react-emotion";
import { Button } from "antd";

import Upload from "./upload";
import DynamicForm from "./DynamicForm";
import * as actions from "../../actions";
import Thumbnails from "./Thumbnails";

// -------------------------------- Styles --------
const Container = styled("div")({
  flex: 1,
  margin: "5px",
  overflow: "auto"
});

const Border = styled("div")({
  height: "100vh",
  borderRight: "1px solid #e8e8e8"
});

// --------------------------------------------------
class ControlBar extends Component {
  state = {
    loading: false
  };

  changeValue = (name, value, index) => {
    /**
     * TODO:
     */
    if (name === "headlines") this.props.changeHeadline(index, value);
    else if (name === "descriptions")
      this.props.changeDescription(index, value);
    this.props.createPreviewImages();
  };

  handleBusinessNameChange = (name, value, index) => {
    this.props.changeBusinessName(index, value);
    this.props.createPreviewImages();
  };

  handleRemoveHeadline = index => {
    this.props.removeHeadline(index);
    this.props.createPreviewImages();
  };

  handleRemoveDescription = index => {
    this.props.removeDescription(index);
    this.props.createPreviewImages();
  };

  handleEditImages = () => {
    this.props.showUploadModal({ showModal: true, loading: false });
  };

  filterImages = images => {
    return images && images.filter(image => image.uid !== undefined);
  };

  renderThumbnails = () => {
    const { croppedImages, croppedLogos } = this.props;
    const filteredImages = this.filterImages([
      ...croppedImages,
      ...croppedLogos
    ]);
    if (filteredImages.length > 0)
      return (
        <Thumbnails
          selectedImages={filteredImages}
          onEditImages={this.handleEditImages}
        />
      );
    return null;
  };

  render() {
    return (
      <Container>
        <Border>
          <Upload
            onAddingImage={this.props.addImage}
            handleImagePreview={this.props.handleImagePreview}
            handleRemove={this.props.handleRemove}
          />
          {this.renderThumbnails()}
          <DynamicForm
            label="Headline"
            name="headlines"
            title="Headlines (up to 5)"
            values={this.props.headlines}
            onAddInput={this.props.addHeadline}
            onRemoveInput={this.handleRemoveHeadline}
            onChangeValue={this.changeValue}
            maxCharLength={30}
            maxFieldsLength={5}
          />
          <DynamicForm
            label="Description"
            name="descriptions"
            title="Descriptions (up to 5)"
            values={this.props.descriptions}
            onAddInput={this.props.addDescription}
            onRemoveInput={this.handleRemoveDescription}
            onChangeValue={this.changeValue}
            maxCharLength={90}
            maxFieldsLength={5}
          />
          <DynamicForm
            label="Business name"
            name="business name"
            title="Business name"
            values={this.props.businessName}
            onChangeValue={this.handleBusinessNameChange}
            maxCharLength={25}
            maxFieldsLength={1}
          />
        </Border>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  headlines: state.headlines,
  descriptions: state.descriptions,
  businessName: state.businessName,
  images: state.images,
  croppedImages: state.croppedImages,
  croppedLogos: state.croppedLogos
});

export default connect(
  mapStateToProps,
  actions
)(ControlBar);
